import { RootState } from '@store/reducers';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import './demographics.css';
import Button from '@components/common/Button';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import { InputGroup, Modal, Spinner } from 'react-bootstrap';
import Vectoricon from '../../../../assets/svg/Vector.svg';
import { DatePicker } from 'antd';
import InfoBar from '@components/common/InfoBars';
import { getData, postDataJSON } from '../../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import { beneficiaryAlreadyInRCH, setBeneficiaryData, setBeneficiaryMobileNumber, updateChild } from '@store/actions/beneficiaryAction';
import { encode, decode, encodeWithKeyAndShift, decryptData, decodeWithKeyAndShift } from '../../../../utils/base64Utils';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { sanitizeName } from '@utils/childUtils';
import { errorLogger } from '@utils/applicationLogUtils';
import { isValueContainsOnlyDigits } from '@utils/hrpConditionCheck';
import { dateFormate, GENDER } from '@constants/index';
import { benef_const, benef_error_const } from '@constants/beneficiaryConstant';
import dayjs from 'dayjs';
import SearchableDropdownComponent from '@components/common/SearchableDropDown';
import { getChildGender } from '@services/childApiServices';
import { prepareBeneficiaryImageForDisplay } from '@utils/childUtils';
interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string, abhaNumber?: any, mob?: any, abhaBenefData?: any, benfData?: any) => void;
    setLinkedBenefDetails: Dispatch<SetStateAction<string>>;
};
const Demographic = ({ showModal, handleClose, setLinkedBenefDetails }: showModalProps) => {
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const [date, setDate] = useState<any>('');
    const [name, setName] = useState<string>('');
    const [nameError, setNameError] = useState<boolean>(false);
    const [dateError, setDateError] = useState<boolean>(false);
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const [dataError, setDataError] = useState<boolean>(false);
    const [errormsg,setErrorMsg]=useState<string>('');
    const [mobError, setMobError] = useState<boolean>(false);
    const [mobileNumber, setMobileNumber] = useState<string>("");
    const [mobileErrorMessage, setMobileErrorMessage] = useState<string>();
    const [isMobileError, setIsMobileError] = useState<boolean>(false);
    const userStateCode = localStorage.getItem('userStateCode');
    const userDistrictCode = localStorage.getItem('userDistrictCode');
    const aadhar = useSelector((state: RootState) => state.beneficiary?.aadhar);
    const [dataOptions, setDataOptions] = useState<any[]>([]);
    const [genderValue, setGenderValue] = useState<any>();
    const [isGenderError, setIsGenderError] = useState<any>({});
    const isChildRegistration = useSelector((state: RootState) => state.beneficiary?.isChildRegistration);


    const dispatch = useDispatch()
    const handleAuthClick = (authType: string, abhaNumber?: any, mob?: any, abhaAddress?: any, benfData?: any) => {
        handleClose(authType, abhaNumber, mob, abhaAddress, benfData);
    };

    useEffect(() => {
        initialFetch();
    },[])

    const initialFetch = async () => {
    const genderData = await getChildGender();
      const genderOptions = genderData?.data[0]?.map((key: any) => ({
        value: key.gender_name,
        label: key.gender_name,
        id: key.gender_id,
        code: key.gender_code,
      }));
      setDataOptions(genderOptions || []);
    }
    const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
        <div>
            <p><strong>ABDM:</strong> {abdmMessage}</p>
            {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
        </div>
    );

    const handleError = (message: string, rchMessage?: string) => {
        const errorMessage = createErrorMessage(message, rchMessage);
        toast.error(errorMessage, {
            position: "top-center",
        });
        setSHowSpinner(false);
    };

    const onSubmitClick = async () => {
        if(!genderValue) {
            setIsGenderError({
                isError: true,
                message: benef_error_const.genderFieldErrorMessage
            });
        }
        if (name !== '' && date !== '' && mobileNumber.length === 10) {
            const dateOfBirth = new Date(new Date(date).setDate(new Date(date).getDate() + 0)).toLocaleDateString('en-GB').replace(/\//g, '-');
            try {
                    const genderValueData = isChildRegistration ? genderValue?.value : beneficiary?.beneficiaryGender
                    const data = {
                        "aadhaar": aadhar,
                        "name": name,
                        "dateOfBirth": dateOfBirth,
                        "gender": genderValueData === GENDER.FEMALE ? GENDER.female : GENDER.male,
                        "stateCode": userStateCode,
                        "districtCode": userDistrictCode,
                        "mobile": mobileNumber
                    }
                        setSHowSpinner(true);
                        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
                        const response = await postDataJSON<any>(`${endpoints.verifyAbhaByAadharDemoauth}`, { data: encodedPayload });
                        const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
                        const difference = dayjs().diff(dayjs(dateOfBirth, "DD-MM-YYYY"), "year");
                        if(decodedData?.Aadhaar?.includes('Invalid Aadhaar Number')){
                            handleError(`${decodedData.Aadhaar}`, benef_error_const?.provideCorrectAadhaar);
                        }
                        else if (decodedData?.message?.includes("information didn't match")) {
                            handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.provideCorrectPersonalDetails);
                        }
                        else if (decodedData?.message?.includes('Runtime Error')) {
                            handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.urlNotFound);
                        }
                        else if (decodedData?.message?.includes('Missing Credentials')) {
                            handleError(`${decodedData?.code} - ${decodedData.description}`);
                        }
                        else if((!isChildRegistration && difference < benef_const.childMinimumAge)|| (isChildRegistration && difference > benef_const.childMinimumAge)){
                            handleAuthClick('close')
                            toast.error(isChildRegistration? benef_const.childBeneficiaryMaxAgeErrorMessage : benef_const.childBeneficiaryRegisterErrorMessage, {
                                position: "top-center"
                            })
                            handleClose('backToOtherMethod');
                            setSHowSpinner(false);
                            setName('')
                            setDate('');
                            setMobileNumber('');
                            setNameError(false);
                            setDateError(false);
                            setDataError(false);
                            setMobError(false);
                        }
                        else if(decodedData?.message?.includes('Too many request attempted')){
                            handleError(`${decodedData?.message}`);
                        }
                        else if (!decodedData.mobile) {
                            toast.error("Aadhaar not linked to any mobile no. Please use another method of registration.", {
                                position: "top-center"
                            })
                            handleClose('backToOtherMethod');
                            setSHowSpinner(false);
                            setName('')
                            setDate('');
                            setMobileNumber('');
                            setNameError(false);
                            setDateError(false);
                            setDataError(false);
                            setMobError(false);
                        }
                        else {
                            try {
                                const mobData = {
                                    mobileNumber: mobileNumber
                                }
                                const encodedData = encodeWithKeyAndShift(JSON.stringify(mobData));
                                const benfData = {
                                    name: name,
                                    abhaId: decodedData.healthIdNumber.replace('-', ''),
                                    gender: isChildRegistration ? genderValue?.value ? (genderValue?.value === GENDER.FEMALE ? GENDER.female : GENDER.male) : GENDER.male : beneficiary?.beneficiaryGender,
                                    dob: new Date(new Date(date).setDate(new Date(date).getDate() + 0)).
                                        toLocaleDateString('en-GB').replace(/\//g, '-'),
                                    mob: mobileNumber,
                                    address: decodedData.healthId,
                                    profile: decodedData?.profilePhoto,
                                    kycVerified: decodedData.kycVerified
                                }
                                if (isChildRegistration && decodedData?.profilePhoto) {
                                    const convertPhotoToFormType = await prepareBeneficiaryImageForDisplay(decodedData?.profilePhoto || '');
                                    dispatch(updateChild('childImageData', convertPhotoToFormType.formData))
                                }
                                dispatch(setBeneficiaryData([benfData]));
                                const mobNumCheckResponse = await postDataJSON<any>(`${endpoints.checkBenefMobileNumberExists}`, { data: encodedData });
                                const decodedResponse = JSON.parse(decodeWithKeyAndShift(mobNumCheckResponse.data.data));
                                setLinkedBenefDetails(decodedResponse.benefDetails)
                            if (decodedResponse.isBenefExist === false) {
                                    dispatch(beneficiaryAlreadyInRCH(false));
                                    setSHowSpinner(false);
                                    handleAuthClick('submit',decodedData.healthIdNumber.replace('-', ''), mobileNumber, decodedData?.healthId, benfData)
                                    setName('')
                                    setDate('');
                                    setMobileNumber('');
                                    setNameError(false);
                                    setDateError(false);
                                    setDataError(false);
                                    setMobError(false);
                                }
                                else {
                                    dispatch(beneficiaryAlreadyInRCH(true))
                                    dispatch(setBeneficiaryMobileNumber(`${mobileNumber}`));
                                    setLinkedBenefDetails(decodedResponse.benefDetails);
                                    setSHowSpinner(false);
                                    handleClose('show-exist-modal');
                                    setName('')
                                    setDate('');
                                    setMobileNumber('');
                                    setNameError(false);
                                    setDateError(false);
                                    setDataError(false);
                                    setMobError(false);
                                }
                            } catch (error) {
                                setSHowSpinner(false);
                                handleError(benef_error_const?.unableToGenerateOtp)
                            }
                        }
            }
            catch (error: any) {
                const decodedData = JSON.parse(decodeWithKeyAndShift(error));
                const res = decodedData;
                let catchErrorMessage = '';
                if(res?.message && res?.code){
                    catchErrorMessage =`${res?.code} - ${res?.message}`
                }else if(res?.message && !res?.code){
                    catchErrorMessage =`${res?.message}`
                }else if(res?.loginId){
                    catchErrorMessage =`${res?.loginId}`
                }else if(res?.Aadhaar){
                    catchErrorMessage =`${res?.Aadhaar}`
                }else{
                    catchErrorMessage = benef_error_const.genericAbdmMessage
                } 
                handleError(catchErrorMessage);
                errorLogger(res, "Aadhar Demo - verifyAbhaByAadharDemoauth");
            }
        }
        else {
            if (name === '') {
                setNameError(true);
            }
            if (date === '') {
                setDateError(true)
            }
            if (mobileNumber.length !== 10) {
                setMobileErrorMessage("Mobile number Must Contain 10 Digits. Enter a valid Mobile number.")
                setIsMobileError(true);
            }
        }

    }
    function handleBackClick(): void {
        handleAuthClick('back');
        setName('')
        setDate('');
        setMobileNumber('');
        setNameError(false);
        setDateError(false);
        setDataError(false);
        setMobError(false);
    }

    function handleDiscardClick(): void {
        handleAuthClick('');
        setName('')
        setDate('');
        setMobileNumber('');
        setNameError(false);
        setDateError(false);
        setDataError(false);
        setMobError(false);
        dispatch(updateChild('isChildRegistration', false));
    }
    const handleMobileChange = (event: any) => {
        const isValue = isValueContainsOnlyDigits(event);
        setIsMobileError(false);
        if(isValue) {
            setMobileNumber(event);
        } else if(event.length === 0) {
            setMobileNumber('');
        }
    }

    const handleBenfNameChange = (event: any) => {
       const sanitizedValue = sanitizeName(event);
       setName(sanitizedValue)
     };

    const handleFormChange = (value: any, key: string, id: any, option: any, code: any, changedData:any) => { 
        setGenderValue(value);
        setIsGenderError({
            isError: false,
            message: ''
        });
    }
    useEffect(() => { }, [dateError])
    return (
        <>
            <div className="modal_auth_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => {
                        setName('')
                        setDate('');
                        setNameError(false);
                        setDateError(false);
                        setDataError(false);
                        setMobError(false);
                        handleAuthClick('close')
                    }}
                    dialogClassName={'auth-card-modal'}
                    centered={true}>
                    <Modal.Header>
                        <div className='demographic_card_header'>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>
                    <Modal.Body  >
                        <div className='demographic_container'>
                            <div className='demographic_id_container'>
                                <h4 className='demographic_headings'>Register with {beneficiary?.beneficiaryRedgeOption} ({beneficiary?.beneficiaryAuthType})</h4>
                                <div className='demographic_input_fields'>
                                    <InputFieldsComponent
                                        labelName="Beneficiary Name(As per Aadhaar)"
                                        placeholder={"Type Here"}
                                        dataTestId='beneficiary-name'
                                        type={'text'}
                                        isDisabled={false}
                                        errorMessage={"Beneficiary name cannot be empty"}
                                        inputType={nameError ? 'error' : 'general'}
                                        onChange={handleBenfNameChange}
                                        required={true}
                                        value={name}
                                    />
                                    <InputFieldsComponent
                                        labelName="Mobile Number Linked with Aadhaar"
                                        placeholder={"Type Here"}
                                        type={'text'}
                                        isDisabled={false}
                                        dataTestId='mobile-number'
                                        maximumLength={10}
                                        errorMessage={mobileErrorMessage}
                                        inputType={isMobileError ? 'error' : 'general'}
                                        onChange={handleMobileChange}
                                        value={mobileNumber}
                                        required={true} />

                                    {!isChildRegistration ?
                                    <InputFieldsComponent
                                        labelName="Gender"
                                        placeholder={''}
                                        type={'text'}
                                        isDisabled={true}
                                        onChange={() => { }}
                                        required={true}
                                        value={beneficiary?.beneficiaryGender}
                                    />:
                                    <SearchableDropdownComponent
                                        options={dataOptions}
                                        onChange={(changedData: any) => handleFormChange(changedData, 'gender', changedData?.id, dataOptions, changedData?.code, changedData)}
                                        placeHolder={benef_const.gender}
                                        multipleSelection={false}
                                        dropDownType={isGenderError?.isError ? 'error' : 'general'}
                                        dropLabelName={benef_const.gender}
                                        ifRequired={true}
                                        dropDownDisable={false}
                                        dropdownsearchable={true}
                                        value={genderValue}
                                        errorMessage={isGenderError?.message}
                                        isClearable={true}
                                    />}
                                    <div className={`input-field-container`}>
                                        <label
                                            className={`label-name-from-parent ${true && 'yes'} false`}
                                        >
                                            {"Beneficiary DOB"}
                                        </label>
                                        <InputGroup>
                                            <DatePicker 
                                                style={{ width: "100%" }} 
                                                format={dateFormate.dd_mm_yyyy} 
                                                placeholder={dateFormate.ddmmyyyy} 
                                                onChange={(event) => setDate(event)} 
                                                value={date} 
                                                disabled={false} 
                                                popupClassName='date-picker-popup' 
                                                suffixIcon={<Vectoricon />}
                                                maxDate={isChildRegistration ? dayjs(new Date()) : undefined}
                                                minDate={isChildRegistration ? dayjs().subtract(5, 'year') : undefined}
                                            />
                                        </InputGroup>
                                        <div className="input_field_infoBars">
                                            {dateError && (
                                                <InfoBar
                                                    variant="danger"
                                                    message={'Beneficiary Date cannot be empty'}
                                                    className="input_field_class"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='demographic-beneficiary-submit-button'>
                                <Button
                                    onClick={onSubmitClick}
                                    id="demographic-beneficiary-submit"
                                    buttonName={'Submit'}
                                    colorType={'primary'}
                                />
                            </div>
                            <div className="input_field_infoBars">
                                {dataError && (
                                    <InfoBar
                                        variant="danger"
                                        message={errormsg}
                                        className="input_field_class"
                                    />
                                )}
                                {mobError && (
                                    <InfoBar
                                        variant="danger"
                                        message={'Beneficiary already exists under the mobile number'}
                                        className="input_field_class"
                                    />
                                )}
                            </div>
                            <span>{showSpinner && (<><span>Loading...</span><Spinner /></>)} </span>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default Demographic;
